// extracted by mini-css-extract-plugin
module.exports = {"select":"DayPicker_select__AEcj_","wrapper--full-width":"DayPicker_wrapper--full-width__TP0bH"};